import type { Plugin } from 'vue';
import VueSignaturePad from 'vue-signature-pad';

export default defineNuxtPlugin((nuxtApp) => {
  // * VueSignaturePad doesn't have typings and types that is in decs.d.ts is not suitable here for some reason, so that is why Type Assertion is used here
  nuxtApp.vueApp.use(VueSignaturePad as unknown as Plugin);
});
